import {AssistantPanel, cn} from '@chekinapp/ui';
import {RAIL_STRIP_REVEAL, RAIL_VARIANTS, RailToggle} from 'components/CollapsibleRail';

type Props = {
  label: string;
  expandLabel: string;
  onExpand: () => void;
  controls?: string;
  animate?: boolean;
};

function VelaCollapsedStrip({label, expandLabel, onExpand, controls, animate}: Props) {
  return (
    <div
      className={cn(
        'sticky top-[var(--maintenance-banner-height,0px)] h-[var(--app-dvh,100dvh)] w-full flex-col items-center gap-3 self-start border-l border-[var(--rail-border)] bg-[var(--rail-bg)] py-[var(--rail-py)]',
        RAIL_VARIANTS.vela.strip,
        animate && RAIL_STRIP_REVEAL,
      )}
    >
      <RailToggle
        isOpen={false}
        onToggle={onExpand}
        expandLabel={expandLabel}
        rail="vela"
        controls={controls}
      />
      <div className="mt-[18px] flex justify-center self-stretch border-t border-[var(--rail-border)] pt-4 motion-safe:animate-in motion-safe:fade-in-0 motion-safe:[animation-delay:150ms] motion-safe:[animation-duration:240ms] motion-safe:[animation-fill-mode:both]">
        <AssistantPanel.Avatar />
      </div>
      <span className="sr-only">{label}</span>
    </div>
  );
}

export {VelaCollapsedStrip};
